import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { scanListRequest } from "../../redux/actions/scanListActions";
import "../../styles/InputSheet.css";
import { MdSearch, MdVisibility } from "react-icons/md";
import Pagination from "../../helper/Pagination";
import ScanDetailsOffcanvas from "../../helper/ScanDetailsOffcanvas";
import { FaSearch } from "react-icons/fa";

const ScanList = () => {
  const dispatch = useDispatch();
  const { loading, scans, totalCount, error } = useSelector(
    (state) =>
      state.scanList || {
        loading: false,
        scans: [],
        totalCount: 0,
        error: null,
      }
  );
  const [search, setSearch] = useState("");
  const [selectedScan, setSelectedScan] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("user") || "{}");
    const oemId = userData.oemPartner?.id;
    if (oemId) {
      dispatch(scanListRequest(oemId, search, page, limit));
    }
  }, [dispatch, search, page, limit]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleViewDetails = (scan) => {
    setSelectedScan(scan);
    setShowOffcanvas(true);
  };

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div
          className="mt-2 d-flex align-items-end justify-content-between"
          style={{ padding: "0 20px" }}
        >
          <div>
            <p style={{ color: "black", margin: "5px 0 0 0" }}>
              Total Scans: {totalCount}
            </p>
          </div>
          {/* Search Bar */}
          <div className="position-relative d-flex justify-content-end">
            <input
              type="search"
              placeholder="Search scans...."
              className="form-input"
              value={search}
              onChange={handleSearch}
              style={{ width: "220px" }}
            />
            {search === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  transform: "translateY(-50%)",
                  color: "#666",
                }}
              >
                <FaSearch/>
              </div>
            )}
          </div>
        </div>
        <div className="input-form-section">
          <div className="table-scroll-wrapper">
            <table className="partners-table">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Date/Time</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Domains</th>
                  <th>Language</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="7"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#666",
                      }}
                    >
                      <div className="loading-spinner">
                      </div>
                    </td>
                  </tr>
                ) : scans?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="7"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#666",
                      }}
                    >
                      No scan-list found
                    </td>
                  </tr>
                ) : (
                  scans.map((scan, index) => (
                    <tr key={scan._id}>
                      <td>{(page - 1) * limit + index + 1}</td>
                      <td>
                        {new Date(scan.createdAt).toLocaleDateString()}
                        <br />
                        <small>
                          {new Date(scan.createdAt).toLocaleTimeString()}
                        </small>
                      </td>
                      <td>
                        {scan.firstName
                          ? scan.firstName.charAt(0).toUpperCase() +
                            scan.firstName.slice(1)
                          : ""}{" "}
                        {scan.lastName
                          ? scan.lastName.charAt(0).toUpperCase() +
                            scan.lastName.slice(1)
                          : ""}
                      </td>

                      <td>{scan.email}</td>
                      <td>
                        {scan.domains.slice(0, 2).join(", ")}
                        {scan.domains.length > 2 && (
                          <small> (+{scan.domains.length - 2} more)</small>
                        )}
                      </td>
                      <td>{scan.language === "eng" ? "English" : "Japanese"}</td>
                      <td>
                        <div className="row-actions">
                          <MdVisibility
                            onClick={() => handleViewDetails(scan)}
                            className="info_pointer fs-5"
                            title="View Details"
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <Pagination
          currentPage={page}
          totalPages={Math.ceil(totalCount / limit)}
          totalItems={totalCount}
          itemsPerPage={limit}
          onPageChange={setPage}
        />

        <ScanDetailsOffcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          scanData={selectedScan}
        />
      </div>
    </div>
  );
};

export default ScanList;
